window.application.register("tooltip", 
	class extends Stimulus.Controller {
		static get targets() {
		  return [  ]
		}
		
		connect(){
			this.element[this.identifier] = this;
			tippy(this.element,{
				content:this.data.get('content'),
				animation:'scale',
				maxWidth:220,
				theme:'fwd'
			});
			
		}

		
		disconnect(){
			try{this.tearDown()}catch(err){};
		}

		tearDown(){
			// this.destroySwiper();
		}

	}
)